import { Inject, Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { ENVIRONMENT } from 'environments-lib';
import { IEnvironment } from 'interfaces-lib';
import { StorageService } from './storage.service';

export type Identity = { namespace: Namespace; tenant: string; token: string };

/**
 * Stores the currently logged in identity information.
 */
@Injectable({ providedIn: 'root' })
export class IdentityStorage extends StorageService<Identity> {
  constructor(@Inject(ENVIRONMENT) protected environment: Partial<IEnvironment>) {
    super('kp-identity', environment.identityStorageType);
  }
}
